import { render, staticRenderFns } from "./LibIconDelete.vue?vue&type=template&id=7aff3a36&"
import script from "./LibIconDelete.vue?vue&type=script&lang=ts&"
export * from "./LibIconDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports